import { Text, Colors } from '@amelio/ui-library';

import { Bone, Skeleton } from '@/components/Skeleton/Skeleton';

export const CompetencySummarySkeleton = () => {
    return (
        <div className={'mt-10'}>
            <Skeleton>
                {/* Section Title */}
                <Text
                    size={'small'}
                    weight={'semibold'}
                    color={Colors.BASE_400}
                    className={'mb-2 tracking-widest uppercase'}
                >
                    <Bone className={'h-4 w-32'} />
                </Text>

                {/* Competency Tiles */}
                <div className={'grid grid-cols-5 gap-6'}>
                    {Array.from({ length: 4 }).map((_, index) => (
                        <CompetencyTileSkeleton key={index} />
                    ))}
                </div>
            </Skeleton>
        </div>
    );
};

const CompetencyTileSkeleton = () => {
    return (
        <div
            className={
                'flex flex-col gap-1 rounded-lg border bg-gradient-to-br from-white/60 to-white/40 px-4 py-4 shadow-sm'
            }
            style={{ borderColor: '#e5e7eb33' }}
        >
            {/* Proficiency Level Label */}
            <Bone className={'h-3 w-20'} />

            {/* Competency Count */}
            <Bone className={'h-8 w-12'} />
        </div>
    );
};

CompetencySummarySkeleton.displayName = 'CompetencySummarySkeleton';
